export const getAge = (age: number, ageUnit?: string): number => {
  if (ageUnit === 'm') {
    return age / 12
  } else if (ageUnit === 'd') {
    return age / 365
  } else {
    return age
  }
}
